import {OverlayTrigger} from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import React from "react";
import uuid from "react-uuid";

interface OverlayedHyperlinkInterface {
  placement:     string,
  overlayTxt:    string,
  href:          string,
  linkTxt:       string,
  linkClassName: string,
  target:        '_self'|'_blank'|'_parent'|'_top',
  download:      boolean,
}

const OverlayedHyperlink = ({placement, overlayTxt, href, linkTxt, linkClassName, target, download}: OverlayedHyperlinkInterface) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
          <Tooltip id={`tooltip-${uuid()}`}>
            {overlayTxt}
          </Tooltip>
      }
    >
      <a
        {... {
          href,
          className: linkClassName,
          download,
          target
      }}>
        {linkTxt}
      </a>
    </OverlayTrigger>
  )
}

export default OverlayedHyperlink;
